import { useEffect } from 'react';
import { CILogger } from 'common/log/log.provider';
import { useSelector } from 'react-redux';
import type { RootState } from 'store';
import { useRetry } from './useRetry';

export const useDetectPendoFailure = () => {
    const auth = useSelector((state: RootState) => state.auth);
    const { activeUser } = auth;

    const retry = useRetry();

    useEffect(() => {
        const checkPendoStatus = async () => {
            // Log error only if user is authenticated
            if (activeUser) {
                try {
                    await retry(
                        () => {
                            return new Promise((resolve, reject) => {
                                if ((window as any).pendoLoadError) {
                                    reject((window as any).pendoErrorDetails || 'Unknown Error');
                                } else {
                                    resolve(true);
                                }
                            });
                        },
                        5, // 5 retries
                        2000 // 2 second initial delay
                    );
                } catch (error) {
                    CILogger.getInstance().error('Pendo analytics service failed to load.', error);
                }
            }
        };

        checkPendoStatus();
    }, [activeUser]);
};
